export * from "./utils";
export * from "./QRCodeCanvas";
export * from "./QRCodeSVG";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@rc-component/qrcode/es/index.js
// module id = 1996
// module chunks = 0